// extracted by mini-css-extract-plugin
export default {"nodataContainer":"NoResult_nodataContainer__x34Yd","nodataContent":"NoResult_nodataContent__msRX2","label":"NoResult_label__F+SAQ"};